import { Link as RouterLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 312px;
`;

export const AppItem = styled(RouterLink)<{ $active?: boolean }>`
  height: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  padding: 10px 18px;

  ${({ $active }) => $active && css`
    background: #002952;
    pointer-events: none;
  `}

  svg {
    width: 24px;
    height: 24px;
  }

  &:hover {
    background: #002952;
  }
`;

export const AppLink = styled.a`
  height: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  padding: 10px 18px;

  svg {
    width: 24px;
    height: 24px;
  }

  &:hover {
    background: #002952;
  }
`;

export const AppItemTitle = styled.span<{ $bold?: boolean }>`
  flex: 1;
  font-family: Inter;
  font-size: 14px;
  line-height: 16px;
  color: #fff;

  ${({ $bold }) => $bold && css`
    font-weight: 600;
  `}
`;

export const Toggle = styled.button<{ $rotate?: string }>`
  display: flex;
  align-items: center;
  padding: 0 6px;
  height: 36px;
  background: transparent;
  border-radius: 4px;
  border: 1px solid #072F52;
  transition: background 0.2s;

  & > svg {
    transition: transform 0.2s;
  }

  &:hover,
  &.ant-popover-open {
    background: var(--Denim, #1271A6);
  }

  &.ant-popover-open {
    & > svg {
      transform: rotate(180deg);
    }
  }
`;

export const Box = styled.div`
  background: #0E2338;
  border-radius: 8px;
  margin-top: 4px;
  box-shadow: 0 20px 24px -4px var(--Colors-Effects-Shadows-shadow-xl_01, rgba(16, 24, 40, 0.08)), 0 8px 8px -4px var(--Colors-Effects-Shadows-shadow-xl_02, rgba(16, 24, 40, 0.03));
`;

export const ProfileImg = styled.img<{ $shadow?: boolean }>`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1.3px solid var(--Denim, #1271A6);

  ${({ $shadow }) => $shadow && css`
    box-shadow: 0 1px 3px 0 rgba(16, 24, 40, 0.15), 0 1px 2px -1px rgba(16, 24, 40, 0.15);
  `}
`;

export const ProfileUser = styled.span`
  color: #FFF;
  font-family: Inter;
  font-size: var(--Font-size-text-sm, 14px);
  font-weight: 600;
  line-height: var(--Line-height-text-sm, 20px);
  word-break: break-word;
`;

export const ProfileSection = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 18px;
  border-bottom: 1px solid #415B91;
  gap: 8px;
`;

export const FooterSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  padding: 18px 8px;
  border-top: 1px solid #E4E7EC;
  gap: 8px;
`;

export const LogoutButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: #FFF0F0;
  color: #F00000;
  border: none;
  font-family: Inter;
  font-size: 14px;
  line-height: 16px;
  border-radius: 8px;
  transition: background 0.2s;

  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
`;

export const SwitcherWrap = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #415B91;
  padding-bottom: 10px;
  padding: 2px 0 12px;
`;

export const ShifterWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 16px 0;
  opacity: 0.6;
`;

export const ShifterText = styled.span`
  color: var(--Denim, #1271A6);
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
`;

export const ActiveBadge = styled.div`
  border-radius: 20px;
  background: var(--Color-5, #ECF3F6);
  padding: 4px 8px;
  color: var(--Color-2, #171717);
  font-family: Inter;
  font-size: 10px;
  line-height: 12px;
`;
